// 判定某个异步回调是否仍属于当前 AI WebSocket 连接。
// 会话轮换/重连会产生新旧两条连接，旧连接的迟到回调（onopen/onmessage/onclose…）
// 必须整体忽略，否则会出现串轮次渲染。对应小程序侧 utils/aiSocketConnection.js。
export function isCurrentAiSocketConnection({
  currentUrl,
  currentSocket,
  connectionUrl,
  connectionSocket,
}) {
  if (currentUrl !== connectionUrl) return false;
  return !connectionSocket || currentSocket === connectionSocket;
}

export default {
  isCurrentAiSocketConnection,
};
